import styled from 'styled-components';
import themeHelper from '../../utils/themeHelper';

export const PageContainer = styled.div`
  display: flex;
  height: 100vh;
  ${({ $isTouch }) => $isTouch && 'flex-direction: column;'}
`;

export const NavContainer = styled.div`
  background: ${({ theme }) => theme.colours.canvas.tertiary.main};
  z-index: 1;
`;

export const PageSection = styled.section`
  height: 100%;
  isolation: isolate;
  overflow-y: auto;
  padding: ${themeHelper.spacing(1)};
  width: 100%;
`;
